import React from 'react';
import { configure_customers_select } from '../utils/DictionaryManagementUtils';
import DefaultRecipientList from '../components/PanelsComponents/DefaultPanels/DefaultRecipientList';

//= ========================================================================

const Panel_F02_RequestPaymentRecipientList = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
}) => (
  <DefaultRecipientList
    globJSON={globJSON}
    onConfigChanged={onConfigChanged}
    onStepPressed={onStepPressed}
    onGotoEdit={onGotoEdit}
    selectedScreen={selectedScreen}
    paragraph={configure_customers_select}
    language={language}
  />
);

export default Panel_F02_RequestPaymentRecipientList;
